import { render, staticRenderFns } from "./mdc-chip.vue?vue&type=template&id=622b4f4b&"
import script from "./mdc-chip.vue?vue&type=script&lang=ts&"
export * from "./mdc-chip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports